import TimeslotIcon from 'components/molecules/TimeslotIcon'
import { StyleSheet, View } from 'react-native'
import React from 'react'

const TimeslotKindView = ({ timeslotKind }) => {
	
	return (
		<View>
			{/* Icon */}
			<View
				style={ staticStyles.viewWidth50Height50}>
				
				<TimeslotIcon
					timeslot={ timeslotKind }
				/>
			</View>
			
			{/* Spacer */}
			<View
				style={staticStyles.viewHeight40}
			/>
		</View>
	)
}

const staticStyles = StyleSheet.create({
	viewWidth50Height50: {
		width: 50,
		height: 50,
		flex: 0,
		margin: 6,
		alignSelf: 'center',
	},
	viewHeight40: {
		height: 40,
	},
});

export default TimeslotKindView;
